/**
 * 从小程序 webview 带入的 session 参数解析与持久化。
 * 优先读 URL query，fallback 到 sessionStorage（应对重定向丢参、页面 reload）。
 */

const STORAGE_KEY = 'complaint_mp_session';

function parseSearchParams(search) {
  const params = {};
  const text = (search || '').replace(/^\?/, '');
  if (!text) {
    return params;
  }
  text.split('&').forEach((pair) => {
    if (!pair) {
      return;
    }
    const idx = pair.indexOf('=');
    const key = idx >= 0 ? decodeURIComponent(pair.slice(0, idx)) : decodeURIComponent(pair);
    const value = idx >= 0 ? decodeURIComponent(pair.slice(idx + 1)) : '';
    params[key] = value;
  });
  return params;
}

/** 从当前页 URL 或 sessionStorage 读取小程序 session。 */
export function resolveMpSession(routeQuery) {
  const query = routeQuery || {};
  const fromRoute = query.session || query.sessionToken || '';
  if (fromRoute) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromRoute);
    } catch (e) {
      // ignore quota / private mode
    }
    return { session: fromRoute, entry: query.entry || '' };
  }

  const fromSearch = parseSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const fromLocation = fromSearch.session || fromSearch.sessionToken || '';
  if (fromLocation) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromLocation);
    } catch (e) {
      // ignore
    }
    return { session: fromLocation, entry: fromSearch.entry || '' };
  }

  if (typeof window !== 'undefined' && window.__COMPLAINT_MP_SESSION__) {
    const bootstrapped = window.__COMPLAINT_MP_SESSION__;
    try {
      sessionStorage.setItem(STORAGE_KEY, bootstrapped);
    } catch (e) {
      // ignore
    }
    return {
      session: bootstrapped,
      entry: window.__COMPLAINT_MP_ENTRY__ || 'mp',
    };
  }

  try {
    const cached = sessionStorage.getItem(STORAGE_KEY) || '';
    if (cached) {
      return { session: cached, entry: 'mp' };
    }
  } catch (e) {
    // ignore
  }

  return { session: '', entry: query.entry || fromSearch.entry || '' };
}

export function clearMpSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}



// WEBPACK FOOTER //
// ./src/utils/mpSession.js